import { HistoryListProps } from "@husky-x/history-list";

export const HistoryMockNo: HistoryListProps  = {
	data: [
		{
			year: 1915,
			description: 'LA Jackson grunnlegger London Rubber Company og selger importerte kondomer og tilbehør til barberere.',
		},
		{
			year: 1929,
			description: 'London Rubber Comany (LRC) registrerer Durex-varemerket',
		},
		{
			year: '1950-talet',
			description: 'Durex lanserer sitt første fuktede kondom',
		},
		{
			year: 1953,
			description: 'Durex er det første merket til å utvikle og ta i bruk elektronisk testing',
		},
		{
			year: '1960-talet',
			description: 'Durex lanserer det første anatomisk formede kondomet',
		},
		{
			year: '1970-talet',
			description: 'Durex er verdens første kondommerke som markedsføres i mange land.',
		},
		{
			year: '1990-talet',
			description: 'Durex er det første kondommerket til å ta i bruk et globalt "kvalitetssegl" som standard',
		},
		{
			year: 1995,
			description: 'Durex lanserer en rekke fargerike og smakstilsatte kondomer',
		},
		{
			year: 1996,
			description: 'Durex er det første kondommerket til å lansere egen nettside. Vi nå ha 42 forskjellige nettsteder for landene der vi er representert.',
		},
		{
			year: 1997,
			description: 'Durex lanserer lateksfrie kondomer. Et nytt, ikke-allergifremkallende materiale brukes til det nye produktet: Den syntetiske polyuretanen utviklet av Durex er mykere og mer elastisk enn naturlig gummilateks',
		},
		{
			year: 1998,
			description: 'Durex er det første kondommerket til å utføre og publisere en verdensomspennende spørreundersøkelse om seksuelt velvære.',
		},
		{
			year: 2001,
			description: 'Durex introduserer Pleasuremax. Dette gjør Durex til det første kondommerket som markedsfører et kondom som er både rillet og knudret for å stimulere begge partnere.',
		},
		{
			year: 2003,
			description: 'Durex lanserer et spennende utvalg av Play-glidemidler.',
		},
		{
			year: 2005,
			description: 'Durex Network lanserer Face of Global Sex-rapporter som utforsker aspektene ved seksuell atferd, og som utarbeides for å informere akademikere og politikere.',
		},
		{
			year: 2008,
			description: 'For å fremme sikker sex blant unge oppfordrer Durex ungdom mellom 16 og 24 til å lage en unik plakat om seksuell helse - en plakat av ungdom for tenåringer.',
		},
		{
			year: 2009,
			description: 'Durex fyller 80!',
		},
		{
			year: 2010,
			description: 'Durex støtter initiativet «Condomize!» fra FNs befolkningsfond ved den internasjonale AIDS-konferansen i Wien ved å donere 220.000 kondomer.',
		},
		{
			year: 2010,
			description: 'Durex kjøpes opp av Reckitt Benckiser.',
		},
		{
			year: 2010,
			description: 'Durex lanserer Performax Intense, et kondom beregnet på samtidig klimaks. Med et indre belegg med 5 % benzokain og stimulerende struktur bidrar det til lengre og mer intens sex.',
		},
		{
			year: 2019,
			description: 'Durex fyller 90!',
		},
	]
}